import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    RegenerateAiEmailTemplate as RegenerateAiEmailTemplateMutation,
    RegenerateAiEmailTemplateVariables,
    AiEmailTemplateRegenerateInput,
} from 'nutshell-graphql-types';

import REGENERATE_AI_EMAIL_TEMPLATE from '../mutations/regenerate-ai-email-template.graphql';

export const useRegenerateAiEmailTemplate = (): {
    regenerateAiEmailTemplate: (arg1: AiEmailTemplateRegenerateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [regenerateAiEmailTemplate, {loading, error}] = useMutation<
        RegenerateAiEmailTemplateMutation,
        RegenerateAiEmailTemplateVariables
    >(REGENERATE_AI_EMAIL_TEMPLATE);

    return {
        regenerateAiEmailTemplate: (input: AiEmailTemplateRegenerateInput) =>
            regenerateAiEmailTemplate({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
